/**
 * Workspace Trash Route - View deleted items
 *
 * Shows soft-deleted items that can be restored.
 * Part of the Data Workspace OS feature set.
 */

import { createFileRoute } from '@tanstack/react-router';

import { WorkspacePage } from '@/features/workspace';
import { workspaceSearchSchema } from '@/features/workspace/utils/workspaceSearchSchema';

export const Route = createFileRoute('/_authenticated/_withWorkspace/workspace/trash')({
  component: WorkspaceTrashPage,
  validateSearch: workspaceSearchSchema,
});

function WorkspaceTrashPage() {
  const search = Route.useSearch();

  // Data fetching is handled by useWorkspaceItems via TanStack Query
  // No manual fetch calls needed - queries auto-fetch on mount

  return (
    <WorkspacePage
      showTrash
      folderId={search.folder}
      searchParams={search}
    />
  );
}
